<template lang="html">
  <div class="home_wrap">
      <div class="home_main_title">
        <h1>Home</h1>
      </div>

    <div class="carousel_wra">
      <div class="carousel_cont">
        <carousel :perPage="1" :autoplay="true" :loop="true" :paginationPosition="'bottom-overlay'" :autoplayTimeout="4000">
          <slide v-for="item in carousel">
            <div class="slideshow_image" v-bind:style="{'background-image': 'url('+require('../../assets/banner/work'+item.Fotoid+'.jpg')+')'}"></div>
          </slide>
        </carousel>
      </div>
    </div>

    <div class="service_wrap welkom_wrap">
        <div class="service_container">
            <div class="service_head"><h1>Welkom</h1></div>
            <div class="service_dash"></div>
            <div class="service_detail" style="flex-direction: column; padding-top: 25px; display: none;">
              <h1 class="service_text">J. van den Wijngaart Schilders - Behangers is een familiebedrijf dat is opgericht in 1920 in Amsterdam.
                <br>
                <br>
                Vanuit Amsterdam is het later verhuisd naar ...
              </h1>
              <br>
              <router-link to="/over" style="width: 100%; font-family: 'Segoe UI', sans-serif; font-weight: 500; font-size: 14px; color: #333; text-decoration: none;">Lees Meer</router-link>
            </div>

            <div class="service_details">
              <p>
                J. van den Wijngaart Schilders - Behangers is een familiebedrijf dat is opgericht in 1920 in Amsterdam.
                  <br>
                  <br>
                  Vanuit Amsterdam is het later verhuisd naar ...
              </p>
              <br>
              <router-link to="/over">Lees verder...</router-link>
            </div>
        </div>
    </div>

    <div class="service_wrap">
        <div class="service_container">
            <div class="service_head"><h1>Diensten</h1></div>
            <div class="service_dash"></div>
            <div class="service_details">
              <p>
                Vooraf aan het werk worden al uw wensen besproken en geven wij eerlijk advies.
                Daarbij hoort natuurlijk een duidelijke, gespecificeerde offerte.
                Daarna gaan wij aan de slag.
              </p>
            </div>
            <div class="service_details" style="display: none;">
                <div class="service_detail"><div class="service_icon" id="si1"></div><h1 class="service_text">Snel een afspraak</h1></div>
                <div class="service_detail"><div class="service_icon" id="si2"></div><h1 class="service_text">Inzicht in kleuren</h1></div>
                <div class="service_detail"><div class="service_icon" id="si3"></div><h1 class="service_text">Kwaliteit</h1></div>
            </div>
        </div>
    </div>

    <div class="details_wrap">
      <div class="details_container">
          <div class="detail_item">
            <div class="item_icon"><i class="fas fa-paint-roller"></i></div>
            <div class="item_head"><h1>Schilderen</h1></div>
            <div class="item_text">
              <p>
              Wij schilderen, zowel buiten als binnen, met de
              beste kwaliteit verf en gebruiken daarnaast kwalitatief hoogwaardige materialen.
              </p>
            </div>
            <div class="item_pic" id="schilderen"></div>
          </div>
          <div class="detail_item">
            <div class="item_icon"><i class="fas fa-scroll scroll_icon"></i></div>
            <div class="item_head"><h1>Behangen</h1></div>
            <div class="item_text">
              <p>
              <!--Met behang in huis voelt u zich thuis! -->Door behang in uw huis krijgt u een
              sfeervolle kamer. Normaal behang, glasweefselbehang of fotobehang, wij kunnen
              het voor u plakken.
              </p>
            </div>
            <div class="item_pic" id="behangen"></div>
          </div>
      </div>
    </div>

    <div class="offerte_wrap">
      <div class="offerte_container">
        <h1>Offerteaanvraag</h1>
        <p>
          Bij ons kunt u te allen tijde vrijblijvend een offerte aanvragen.
          Dat doet u door uw gegevens achter te laten,
          zodat wij zo snel mogelijk contact met u kunnen opnemen.
        </p>
        <router-link to="/contact" tag="button">Aanvragen</router-link>
      </div>
    </div>

</div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel';
import $ from 'jquery';
var timeout;

export default {
  components: {
    Carousel,
    Slide
  },
  data() {
    return{
      currentid: 1,
      carousel: [
        {Fotoid: "1", Fotonaam: "work1.jpg"},
        {Fotoid: "2", Fotonaam: "work2.jpg"},
        {Fotoid: "3", Fotonaam: "work3.jpg"},
        {Fotoid: "4", Fotonaam: "work4.jpg"},
        {Fotoid: "5", Fotonaam: "work5.jpg"},
      ]
    }
  },
  methods: {
  },

}
</script>

<style lang="css">

.fadetext-enter-active{transition: 0.8s 0.1s ease;}
.fadetext-leave-active{transition: 0s ease;}

.fadetext-enter{transform: translateX(50px);opacity: 0;}
.fadetext-leave-active{transform: translateX(0px);opacity: 1;}

.home_main_title{
  width: 100%;
  height: 75px;
  padding: 25px 0 0 25px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  display: none;
}

.home_main_title h1{
  font-family: 'Segoe UI', sans-serif;
  font-size: 25px;
  font-weight: 800;
  line-height: 22px;
  color: #222;
  animation: titleanim 0.8s ease 1;
}

  @keyframes titleanim{
    0%{
      transform: translateX(50px);opacity: 0;
    }
    100%{
      transform: translateX(0px);opacity: 1;
    }
  }

.offerte_wrap{
  padding: 0px 25px 25px 25px;
}

.offerte_container{
      max-width: 1000px;
      margin: auto;
}

.offerte_container h1{
  font-size: 25px;
  line-height: 23px;
  font-family: 'Segoe UI', sans-serif;
  font-weight: 800;
  color: #222;
}

.offerte_container p{
  font-size: 14px;
  line-height: 18px;
  font-family: 'Segoe UI', sans-serif;
  font-weight: 400;
  color: #888;
  margin-top: 20px;
}

.offerte_container button{
  width: 100%;
  height: 40px;
  background: #19be6b;
  border-radius: 5px;
  color: #fff;
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 15px;
  opacity: 0.7;
  border: none;
  transition: 0.30s ease;
  margin-top: 20px;
}

.offerte_container button:hover{
  opacity: 1;
  cursor: pointer;
  transition: 0.30s ease;
}

.welkom_wrap{
  display: none;
}

.slideshow_image{
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 500px;
}

.carousel_wra{
  padding: 25px;
}

.carousel_cont{
  max-width: 1000px;
  min-height: 150px;
  overflow: hidden;
  border-radius: 5px;
  margin: auto;
}

.details_wrap{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 0 50px 0;
}

.details_container{
  max-width: 1000px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.details_container .detail_item{
  position: relative;
  width: 500px;
  min-height: 180px;
  //background: #f9f9f9;
  border-radius: 5px;
  margin: 0 10px 0 10px;
  padding: 20px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.05), 0 3px 6px rgba(0,0,0,0.10);
}

.details_container .detail_item .item_pic{
  width: 100%;
  height: 150px;
  margin-top: 25px;
  border-radius: 0 0 5px 5px;
  background-position: right;
  background-size: cover;
}

.details_container .detail_item #schilderen{
  background-image: url('../../assets/img/pic3.jpg');
}

.details_container .detail_item #behangen{
  background-image: url('../../assets/img/pic5.jpg');
}

.details_container .detail_item .item_icon{
  height: 40px;
  width: 40px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #222;
  border-radius: 50%;
  background: #fff;
  padding: 20px;
  font-size: 35px;
  left: calc(50% - 42.5px);
  top: -50px;
}

.details_container .detail_item .item_icon .scroll_icon{
  font-size: 30px;
}

.details_container .detail_item .item_head h1{
  font-size: 30px;
  font-family: 'Segoe UI', sans-serif;
  font-weight: 800;
  color: #222;
  line-height: 23px;
}

.details_container .detail_item .item_text p{
  font-size: 15px;
  font-family: 'Segoe UI', sans-serif;
  font-weight: 400;
  color: #888;
  margin-top: 20px;
  line-height: 25px;
}

.slideshow_wrap{
    padding: 50px 0 50px 0;
    display: flex;
    justify-content: center;
    display: none;
}

.slideshow_container{
    width: 1000px;
    height: 500px;
    border-radius: 10px;
    background-color: #f8f8f8;
    position: relative;
    overflow: hidden;
}

.slideshow_controls{
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}

.slideshow_controls_dots{
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0 20px 0;
    width: 100%;
}

.slideshow_dots{
    height: 15px;
    width: 15px;
    border-radius: 50%;
    box-sizing: border-box;
    background-color: rgba(0,0,0, 0.5);
    margin: 0 5px 0 5px;
    transition: 0.2s ease;
}

.slideshow_dots:hover{
    background-color: rgba(0,0,0, 0.9);
    cursor: pointer;
    transition: 0.2s ease;
}

.slideshow_controls_sides{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.slideshow_controls:hover .slideshow_arrowleft,.slideshow_controls:hover .slideshow_arrowright{
    opacity: 1;
    transition: 0.4s ease;
}

.slideshow_controls_sides .slideshow_arrowleft{
    width: 15px;
    height: 15px;
    border-left: 2px solid #fff;
    border-top: 2px solid #fff;
    transform: rotateZ(-45deg);
    margin-left: 30px;
    opacity: 0.5;
    transition: 0.2s ease;
}

.slideshow_controls_sides .slideshow_arrowleft:hover{
    cursor: pointer;
}

.slideshow_controls_sides .slideshow_arrowright{
    width: 15px;
    height: 15px;
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotateZ(-45deg);
    margin-right: 30px;
    opacity: 0.5;
    transition: 0.2s ease;
}

.slideshow_controls_sides .slideshow_arrowright{
    cursor: pointer;
}

.slideshow_section{
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
}

.slideshow_shape{
    position: absolute;
    width: 1000px;
    height: 500px;
    background: #222;
    transform:  translateX(-550px) translateY(170px) rotate(70deg);
}

.img_animation{
    animation: fadeInAni ease 0.5s 1;
}

@keyframes fadeInAni{
    0%{
        opacity: 0;
    }
    100%{
        opacity: 1;
    }
}

#carousel_img:after{
    content: ' ';
    position: absolute;
    width: 1000px;
    height: 500px;
}

.select_dot{
    background: rgba(255,255,255,0.5);
    transition: 1s ease;
}

.slideshow_controls:hover .select_dot{
    background: #fff;
    transition: 0.4s ease;
}

.slideshow_text_container{
    position: absolute;
    bottom: 0;
    height: calc(100% - 100px);
    width: calc(100% - 100px);
    font-family: 'Segoe UI', sans-serif;
    padding: 50px;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    background-image: linear-gradient(transparent, rgba(0,0,0,0.6));
}

.slideshow_text_container h1{
    color: #fff;
    font-weight: 900;
    font-size: 40px;
    line-height: 35px;
    text-shadow: 3px 3px 3px rgba(0,0,0,0.5);
}

.slideshow_text_container h2{
    color: #ddd;
    font-weight: 300;
    font-size: 18px;
    margin-bottom: 5px;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.8);
}

/*=================
====Service css===
=================*/

.service_wrap{
    padding-bottom: 50px;
}

.service_container{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.service_head{
    display: flex;
    justify-content: center;
}

.service_head h1{
    font-family: 'Segoe UI', sans-serif;
    font-size: 30px;
    font-weight: 800;
    line-height: 22px;
    color: #222;
}

.service_dash{
    width: 300px;
    height: 1px;
    background-color: #ccc;
    margin: 20px 0 20px 0;
}

.service_details{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.service_details a{
    font-family: 'Segoe UI', sans-serif;
    font-size: 15px;
    color: #222;
    //text-decoration: none;
    margin: 0 15px 0 15px;
    position: relative;
}

.service_details a:after{
    position: absolute;
    background-color: #222;
    bottom: -5px;
    right: 0;
    content: ' ';
    height: 1px;
    width: 0%;
    transition: 0.3s ease;
}

.service_details a:hover:after{
    left: 0;
    width: 100%;
    transition: 0.3s ease;
}

.service_detail{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    padding: 0 15px 0 15px;
}

.service_detail .service_icon{
    width: 20px;
    height: 20px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 10px;
    opacity: 0.4;
}

.service_detail .service_text{
    font-family: 'Segoe UI', sans-serif;
    font-weight: 400;
    font-size: 20px;
    color: #aaa;
}

#si1{
    background-image: url('../../assets/img/icon1.png');
}
#si2{
    background-image: url('../../assets/img/icon2.png');
}
#si3{
    background-image: url('../../assets/img/icon3.png');
}

@media only screen and (max-width : 650px) {

  .home_main_title{
    display: flex;
  }

  .welkom_wrap{
    display: block;
  }

  .slideshow_image{
    height: 150px;
  }

  .service_container{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
  }

  .service_wrap{
    padding: 25px 25px 5px 25px;
  }

  .service_head h1{
    font-size: 25px;
  }

  .service_dash{
    margin: 20px 0 20px 0;
    width: 100%;
  }

  .service_details p{
    font-size: 14px;
    line-height: 18px;
    font-family: 'Segoe UI', sans-serif;
    font-weight: 400;
    color: #888;
  }

  .service_detail .service_icon{
    height: 10px;
    width: 10px;
  }

  .service_detail .service_text{
    font-size: 14px;
  }

  .details_wrap{
    padding: 0 25px 0px 25px;
  }

  .details_container{
    flex-direction: column;
    width: 100%;
    max-width: 100%;
  }

  .details_container .detail_item{
    margin: 20px 0 20px 0;
    width: 100%;
    min-height: auto;
    box-sizing: border-box;
  }

  .details_container .detail_item .item_icon{
    width: 25px;
    height: 25px;
    font-size: 18px;
    right: 20px;
    left: auto;
    top: 15px;
    padding: 10px;
  }

  .details_container .detail_item .item_icon .scroll_icon{
    font-size: 16px;
  }

  .details_container .detail_item .item_head h1{
    font-size: 25px;
    padding: 5px 0 5px 0;
  }

  .details_container .detail_item .item_text p{
    font-size: 14px;
    line-height: 18px;
  }

}

</style>
